import React, { useState, useEffect } from 'react';
import EnuitDialog from '../../../components/dialog/EnuitDialog';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import ILogoutUri from '../../../interfaces/clients/IClientLogoutUri';

interface INewLogoutRedirectDialogProps {
  open: boolean;
  onClose: () => void;
  onAdd: (redirect: ILogoutUri) => void;
  clientId: string;
}

function NewClientLogoutRedirectDialog(props: INewLogoutRedirectDialogProps) {
  const { open, onClose, onAdd } = props;
  const [uri, setUri] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    setUri('');
    setErrorMessage('');
  }, [open])

  const handleAddNew = async () => {
    if (uri === '') {
      setErrorMessage('URI is required');
      return;
    }

    const newLogoutUri: ILogoutUri = {
      stringValue: uri
    }

    onAdd(newLogoutUri);
    onClose();
  }

  return (
    <EnuitDialog
      title='New Client Logout Redirect'
      open={open}
      onClose={onClose}
      onOkClick={handleAddNew}
    >
      <Typography>Logout Redirect URI</Typography>
      <TextField
        id='new-client-redirect'
        fullWidth
        size='small'
        value={uri}
        onChange={e => setUri(e.target.value)}
        helperText={errorMessage}
        error={errorMessage !== ''}
      />
    </EnuitDialog>
  )
}

export default NewClientLogoutRedirectDialog